<template>
	<article class="column is-12-mobile is-one-third-widescreen">
		<h3 class="is-size-5 has-text-grey-dark pl-5">Últimas <strong>Avaliações</strong></h3>
		<ul v-if="items.length > 0" class="dashboard__panel dashboard__list">
			<li class="dashboard__list__item dashboard__list__dealer" v-for="(d, i) in items.slice(-5)" :key="i">
				<div>
					<span class="is-block is-medium is-ellipsis" translate="no">{{ d.name }}</span>
					<small class="dashboard__list__date">{{ format(d.date) }} • {{ hour(d.date) }}</small>
				</div>
				<span class="dashboard__list__rate large is-medium">
					<b-tooltip :label="colorLabel(d.rate)" position="is-top">
						<svg-icon icon="star" :class="color(d.rate)"></svg-icon>
						<span>{{ d.rate }}</span>
					</b-tooltip>
				</span>
			</li>
		</ul>
		<Results v-else class="dashboard__panel dashboard__list dashboard__results" title="" message="Ainda não existe<br><strong>nenhuma</strong> avaliação concluída." />
	</article>
</template>

<script>
import Icon from '@/components/Icon'
import Results from '@/components/Results'
import '@/mixins/date'
import '@/mixins/generic'

export default {
	name: 'Ranking',
	components: {
		Results,
		'svg-icon': Icon
	},
	props: {
		items: {
			type: Array,
			required: true
		}
	},
	methods: {
		position(i) {
			return this.order == 'bottom' ? this.items.length - i : i + 1
		}
	}
}
</script>
